import DairyService, { IDairyBank, ILocationOptionData } from '@src/api/services/dairy';
import { useMutation, useQuery } from 'react-query';
import { onError } from '~/utils/helpers';

// Get Dairy Banks Query
const getDairyBanks = () => {
  return useQuery<IDairyBank, Error>('query-banks', DairyService.getDairyBanks, {
    cacheTime: 3000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

// Delete Dairy Bank Query
const deleteDairyBankById = (onSuccess: any) => {
  return useMutation(DairyService.deleteDairyBankById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getDairyBankAccountById = (onSuccess: any) => {
  return useMutation(DairyService.getDairyBankAccountById, {
    onSuccess,
    onError,
    retry: 1
  });
};

// Create Bank Account Query
const createBankAccount = (onSuccess: any) => {
  return useMutation(DairyService.createBankAccount, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editBankAccount = (onSuccess: any) => {
  return useMutation(DairyService.editBankAccount, {
    onSuccess,
    onError,
    retry: 1
  });
};

// Locations querys

const createLocation = (onSuccess: any) => {
  return useMutation(DairyService.createLocation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getLocationOptionData = () => {
  return useQuery<ILocationOptionData, Error>(
    'query-location-option-data',
    DairyService.getLocationOptiondata,
    {
      retry: 1,
      refetchOnMount: false,
      refetchOnWindowFocus: false
    }
  );
};

const dairyLocationsList = (data?) => {
  return useQuery(
    'dairy-locations',
    ({ signal }) => DairyService.getDairyLocations(data, signal),
    {
      onError,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
      select: (data) => {
        return data.data
      }
    }
  )
}

// District querys

const getDairyStates = () => {
  return useQuery('query-districts-states', DairyService.getDairyStates, {
    cacheTime: 3000,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

const getDairyDistrictOptions = () => {
  return useQuery('query-districts-options', DairyService.getDistrictOptions, {
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1
  });
};

// Delete Dairy State Query
const deleteDairyStateById = (onSuccess: any) => {
  return useMutation(DairyService.deleteDairyStateById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getDairyDistrictById = (onSuccess: any) => {
  return useMutation(DairyService.getDairyStateDistrictById, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createDiaryState = (onSuccess: any) => {
  return useMutation(DairyService.createDairyState, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createStateDistrict = (onSuccess: any) => {
  return useMutation(DairyService.createStateDistrict, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editStateDistrict = (onSuccess: any) => {
  return useMutation(DairyService.editStateDistrict, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getMilkTypes = () => {
  return useQuery('query-milk-types', DairyService.getMilkTypes, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editMilkType = (onSuccess: any) => {
  return useMutation(DairyService.editMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createMilkType = (onSuccess: any) => {
  return useMutation(DairyService.createMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteMilkType = (onSuccess: any) => {
  return useMutation(DairyService.deleteMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateMilkType = (onSuccess: any) => {
  return useMutation(DairyService.updateMilkType, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getHusbandryForms = () => {
  return useQuery('query-husbadry', DairyService.getHusbandryForms, {
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.editHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const createHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.createHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.deleteHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateHusbandryForm = (onSuccess: any) => {
  return useMutation(DairyService.updateHusbandryForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const editAssociation = (onSuccess: any) => {
  return useMutation(DairyService.editAssociation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeAssociation = (onSuccess: any) => {
  return useMutation(DairyService.storeAssociation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteAssociation = (onSuccess: any) => {
  return useMutation(DairyService.deleteAssociation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateAssociation = (onSuccess: any) => {
  return useMutation(DairyService.updateAssociation, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getAssociationsList = () => {
  return useQuery('query-associations', DairyService.getAssociationsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editMembershipStatus = (onSuccess: any) => {
  return useMutation(DairyService.editMembershipStatus, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeMembershipStatus = (onSuccess: any) => {
  return useMutation(DairyService.storeMembershipStatus, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteMembershipStatus = (onSuccess: any) => {
  return useMutation(DairyService.deleteMembershipStatus, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateMembershipStatus = (onSuccess: any) => {
  return useMutation(DairyService.updateMembershipStatus, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getMembershipStatusesList = () => {
  return useQuery('query-membership-statuses', DairyService.getMembershipStatusesList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getManagers = (data?) => useQuery(
  'dairy-factory-managers',
  () => DairyService.getManagers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const countManagers = (data?) => useQuery(
  'dairy-factory-count-managers',
  () => DairyService.countManagers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getManagersOptions = () => useQuery(
  'dairy-factory-managers-options',
  DairyService.getManagersOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const showManagerData = (id: string) => useQuery(
  'dairy-factory-show-manager',
  () => DairyService.showManagerData(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const editManager = (id: string) => useQuery(
  'dairy-factory-edit-manager',
  () => DairyService.editManager(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getManagersList = () => useQuery(
  'dairy-factory-list-manager',
  DairyService.getManagersList,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCertificationsList = () => {
  return useQuery('query-certifications', DairyService.getCertifications, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editCollectionCycle = (onSuccess: any) => {
  return useMutation(DairyService.editCollectionCycle, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeCollectionCycle = (onSuccess: any) => {
  return useMutation(DairyService.storeCollectionCycle, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteCollectionCycle = (onSuccess: any) => {
  return useMutation(DairyService.deleteCollectionCycle, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateCollectionCycle = (onSuccess: any) => {
  return useMutation(DairyService.updateCollectionCycle, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getCollectionCyclesList = () => {
  return useQuery('query-collection-cycles', DairyService.getCollectionCyclesList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getContractTypesList = () => {
  return useQuery('query-contract-types', DairyService.getContractTypesList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getCollectionMethodsList = () => {
  return useQuery('query-collection-methods', DairyService.getCollectionMethodsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getBillingGroupsList = () => {
  return useQuery('query-billing-groups', DairyService.getBillingGroupsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getTransportTariffsList = () => {
  return useQuery('query-transport-tariffs', DairyService.getTransportTariffsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editTransportationArea = (onSuccess: any) => {
  return useMutation(DairyService.editTransportationArea, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeTransportationArea = (onSuccess: any) => {
  return useMutation(DairyService.storeTransportationArea, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteTransportationArea = (onSuccess: any) => {
  return useMutation(DairyService.deleteTransportationArea, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateTransportationArea = (onSuccess: any) => {
  return useMutation(DairyService.updateTransportationArea, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getTransportationAreasList = () => {
  return useQuery('query-transportation-areas', DairyService.getTransportationAreasList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editProductionZone = (onSuccess: any) => {
  return useMutation(DairyService.editProductionZone, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeProductionZone = (onSuccess: any) => {
  return useMutation(DairyService.storeProductionZone, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteProductionZone = (onSuccess: any) => {
  return useMutation(DairyService.deleteProductionZone, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateProductionZone = (onSuccess: any) => {
  return useMutation(DairyService.updateProductionZone, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getProductionZonesList = () => {
  return useQuery('query-production-zones', DairyService.getProductionZonesList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editOperatingForm = (onSuccess: any) => {
  return useMutation(DairyService.editOperatingForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeOperatingForm = (onSuccess: any) => {
  return useMutation(DairyService.storeOperatingForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteOperatingForm = (onSuccess: any) => {
  return useMutation(DairyService.deleteOperatingForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateOperatingForm = (onSuccess: any) => {
  return useMutation(DairyService.updateOperatingForm, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getOperatingFormsList = () => {
  return useQuery('query-operating-forms', DairyService.getOperatingFormsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getTransponderIds = (farmerId: string) => {
  return useQuery(['query-transponder-ids', farmerId], () => DairyService.getTransponderIds(farmerId), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    enabled: !!farmerId,
    select: (data) => {
      return data.data
    }
  });
};

const editTransponderId = (onSuccess: any) => {
  return useMutation(({ farmerId, id }: { farmerId: string; id: string }) =>
    DairyService.editTransponderId(farmerId, id), {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeTransponderId = (onSuccess: any) => {
  return useMutation(({ farmerId, data }: { farmerId: string; data: any }) =>
    DairyService.storeTransponderId(farmerId, data), {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteTransponderId = (onSuccess: any) => {
  return useMutation(({ farmerId, id }: { farmerId: string; id: string }) =>
    DairyService.deleteTransponderId(farmerId, id), {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateTransponderId = (onSuccess: any) => {
  return useMutation(({ farmerId, id, data }: { farmerId: string; id: string; data: any }) =>
    DairyService.updateTransponderId(farmerId, id, data), {
    onSuccess,
    onError,
    retry: 1
  });
};

const getCollectionPoints = (data?) => useQuery(
  'dairy-factory-collection-points',
  () => DairyService.getCollectionPoints(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCollectionPointsOptions = () => useQuery(
  'dairy-factory-collection-points-options',
  DairyService.getCollectionPointsOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const showCollectionPoint = (id: string) => useQuery(
  'dairy-factory-show-collection-point',
  () => DairyService.showCollectionPoint(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const editCollectionPoint = (id: string) => useQuery(
  'dairy-factory-edit-collection-point',
  () => Boolean(id) && DairyService.editCollectionPoint(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCollectionSites = (data?) => useQuery(
  'dairy-factory-collection-sites',
  () => DairyService.getCollectionSites(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const editCollectionSite = (id: string) => useQuery(
  'dairy-factory-edit-collection-site',
  () => Boolean(id) && DairyService.editCollectionSite(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getRestrictionPeriods = () => {
  return useQuery('query-restriction-periods', DairyService.getRestrictionPeriods, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const editRestrictionPeriod = (onSuccess: any) => {
  return useMutation(DairyService.editRestrictionPeriod, {
    onSuccess,
    onError,
    retry: 1
  });
};

const storeRestrictionPeriod = (onSuccess: any) => {
  return useMutation(DairyService.storeRestrictionPeriod, {
    onSuccess,
    onError,
    retry: 1
  });
};

const deleteRestrictionPeriod = (onSuccess: any) => {
  return useMutation(DairyService.deleteRestrictionPeriod, {
    onSuccess,
    onError,
    retry: 1
  });
};

const updateRestrictionPeriod = (onSuccess: any) => {
  return useMutation(DairyService.updateRestrictionPeriod, {
    onSuccess,
    onError,
    retry: 1
  });
};

const getRestrictionPeriodsList = () => {
  return useQuery('query-restriction-periods-list', DairyService.getRestrictionPeriodsList, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });
};

const getFarmersOfManager = (id: string, data) => useQuery(
  'managers-farmers-index',
  () => DairyService.getFarmersOfManager(id, data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });

const getCollectionsOfManager = (id: string, data) => useQuery(
  'managers-collection-index',
  () => DairyService.getCollectionsOfManager(id, data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError,
    retry: 1,
    select: (data) => {
      return data.data
    }
  });

const getFinancesManager = (id) => useQuery(
  'managers-show-financial-data',
  () => DairyService.getFinancesManager(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCountriesList = () => useQuery(
  'countries-list',
  DairyService.getCountriesList,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getSegmentationPricesOptions = (data?) => useQuery(
  'segmentation-prices-options',
  () => DairyService.getSegmentationPricesOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getSegmentationFilesOptions = (data?) => useQuery(
  'segmentation-files-options',
  () => DairyService.getSegmentationFilesOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getSegmentationPrices = (data?) => useQuery(
  ['segmentation-prices', JSON.stringify(data)],
  () => DairyService.getSegmentationPrices(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    enabled: Boolean(data?.milkTypeId),
    select: (data) => data.data
  }
)

const storeSegmentationPrice = (onSuccess: any) => {
  return useMutation(DairyService.storeSegmentationPrice, {
    onSuccess,
    onError,
    retry: 1
  })
}

const editSegmentationPrice = (id: string) => useQuery(
  ['segmentation-price-edit', id],
  () => Boolean(id) && DairyService.editSegmentationPrice(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data: any) => data.data
  }
)

const updateSegmentationPrice = (onSuccess: any) => {
  return useMutation(DairyService.updateSegmentationPrice, {
    onSuccess,
    onError,
    retry: 1
  })
}

const getSegmentationFiles = (data?) => useQuery(
  ['segmentation-files', JSON.stringify(data)],
  () => DairyService.getSegmentationFiles(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => data.data
  }
)

const storeSegmentationFile = (onSuccess: any) => {
  return useMutation(DairyService.storeSegmentationFile, {
    onSuccess,
    onError,
    retry: 1
  })
}

const getManagerMilkPaymentsData = (id: string) => useQuery(
  'managers-milk-payments-data',
  () => DairyService.getManagerMilkPaymentsData(id),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getManagerMilkPayments = (id: string, data?: any) => useQuery(
  'managers-milk-payments',
  () => Boolean(id && data?.farmerId) && DairyService.getManagerMilkPayments(id, data),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const DairyQuery = {
  getDairyBanks,
  deleteDairyBankById,
  createBankAccount,
  editBankAccount,
  createLocation,
  getLocationOptionData,
  dairyLocationsList,
  getDairyBankAccountById,
  getDairyStates,
  deleteDairyStateById,
  createDiaryState,
  editStateDistrict,
  getDairyDistrictById,
  getDairyDistrictOptions,
  createStateDistrict,
  getMilkTypes,
  editMilkType,
  createMilkType,
  deleteMilkType,
  updateMilkType,
  createHusbandryForm,
  editHusbandryForm,
  updateHusbandryForm,
  deleteHusbandryForm,
  getHusbandryForms,
  editAssociation,
  storeAssociation,
  deleteAssociation,
  updateAssociation,
  getAssociationsList,
  editMembershipStatus,
  storeMembershipStatus,
  deleteMembershipStatus,
  updateMembershipStatus,
  getMembershipStatusesList,
  getManagers,
  getManagersOptions,
  showManagerData,
  editManager,
  getManagersList,
  getCertificationsList,
  editCollectionCycle,
  storeCollectionCycle,
  deleteCollectionCycle,
  updateCollectionCycle,
  getCollectionCyclesList,
  getContractTypesList,
  getCollectionMethodsList,
  getBillingGroupsList,
  getTransportTariffsList,
  editTransportationArea,
  storeTransportationArea,
  deleteTransportationArea,
  updateTransportationArea,
  getTransportationAreasList,
  editProductionZone,
  storeProductionZone,
  deleteProductionZone,
  updateProductionZone,
  getProductionZonesList,
  editOperatingForm,
  storeOperatingForm,
  deleteOperatingForm,
  updateOperatingForm,
  getOperatingFormsList,
  getTransponderIds,
  editTransponderId,
  storeTransponderId,
  deleteTransponderId,
  updateTransponderId,
  getCollectionPoints,
  getCollectionPointsOptions,
  showCollectionPoint,
  editCollectionPoint,
  getCollectionSites,
  editCollectionSite,
  getRestrictionPeriods,
  getRestrictionPeriodsList,
  editRestrictionPeriod,
  storeRestrictionPeriod,
  deleteRestrictionPeriod,
  updateRestrictionPeriod,
  getFarmersOfManager,
  getCollectionsOfManager,
  getFinancesManager,
  getCountriesList,
  countManagers,
  getSegmentationPricesOptions,
  getSegmentationFilesOptions,
  getSegmentationPrices,
  storeSegmentationPrice,
  editSegmentationPrice,
  updateSegmentationPrice,
  getSegmentationFiles,
  storeSegmentationFile,
  getManagerMilkPaymentsData,
  getManagerMilkPayments
};

export default DairyQuery;
